import * as React from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import styled from "styled-components";

const NavElement = styled.nav`
  display: flex;
  justify-content: space-between;
  padding: 0 1rem 0 1rem;
  margin-bottom: 0.5rem;
  background-color: #ffc107;
  border-bottom: 1px solid #ffc107;
  height: 50px;
  .side,
  .show-on-mobile {
    display: none;
  }

  @media (max-width: 400px) {
    .hide-on-mobile {
      display: block;
    }
    .show-on-mobile {
      display: flex;
      align-items: center;
    }
    .side {
      display: block;
      position: fixed;
      top: 0;
      right: 0;
      width: 350px;
      background: rgba(255, 255, 255, 0.5);
      backdrop-filter: blur(10px);
      z-index: 999;
      height: 100vh;
      li:first-child {
        margin-bottom: 3rem;
      }
      li {
        font-size: 1.5rem;
        font-weight: bold;
        padding: 0.6rem 0;
        margin-bottom: 1rem;
        border-bottom: 1px dotted #ffc107;
      }
    }
  }

  @media (max-width: 768px) {
    .hide-on-mobile {
      display: none;
    }
  }

  ul {
    height: 50px;
    width: 100%;
    list-style: none;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  ul li {
    height: 50px;
    padding-top: 10px;
  }
  ul li:first-child {
    margin-right: auto;
  }
  a {
    font-weight: bold;
    font-size: 1rem;
    line-height: 1;
    padding-top: 9px;
    margin-left: 21px;
    text-decoration: none;
    transition: all ease-in 0.1s;
    &:hover {
      color: white;
    }
  }
`;

const NavbarComponent = () => {
  const [showSidebar, setShowSidebar] = React.useState(false);
  return (
    <NavElement>
      {showSidebar && (
        <ul className="side">
          <li>
            <button onClick={() => setShowSidebar(!showSidebar)}>X</button>
          </li>
          <li>
            <Link to="/">Hem</Link>
          </li>
          {/* TODO: Fix up calculator to look like anyfin's ## */}
          {/* <li>
            <Link to="/lanekalkyl">Lånekalkyl</Link>
          </li> */}
          <li>
            <Link to="/om-oss">Om Oss</Link>
          </li>
        </ul>
      )}
      <ul>
        <li>
          <Link to="/">
            <StaticImage
              placeholder="blurred"
              width={150}
              src="../images/logo.png"
              alt="Smartywak"
            />
          </Link>
        </li>
        <li className="hide-on-mobile">
          <Link to="/samla-lan">Samla lån</Link>
        </li>
        {/* Re-activate after post MVP */}
        {/* <li className="hide-on-mobile">
          <Link to="/lan-utan-sakerhet">Lån utan säkerhet</Link>
        </li> */}

        <li className="hide-on-mobile">
          <Link to="/privatlan">Privatlån</Link>
        </li>
        {/* <li className="hide-on-mobile">
          <Link to="/lanekalkyl">Lånekalkyl</Link>
        </li> */}
        <li className="hide-on-mobile">
          <Link to="/om-oss">Om Oss</Link>
        </li>
        <li className="show-on-mobile">
          <button
            onClick={() => setShowSidebar(!showSidebar)}
            style={{ background: "inherit", border: "none" }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 -960 960 960"
              width="24px"
              fill="#5f6368"
            >
              <path d="M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z" />
            </svg>
          </button>
        </li>
      </ul>
    </NavElement>
  );
};

export default NavbarComponent;
